import React from "react";

export default function TextArea(props) {
	return (
		<textarea placeholder={props.placeholder} rows={props.row ?? 3} {...props}>{props.children}</textarea>
	)
}